module.exports = __webpack_public_path__ + "img/triangle-75.d40146fb.gif";